import React, { useContext, useState, useEffect } from 'react'
import { Form, Modal, ListGroup, Row, Col } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { useTable } from 'react-table'
import styled from 'styled-components'
import { useMediaQuery } from '@mui/material'
import Button from '@mui/material/Button'
import Typography from '@material-ui/core/Typography'

import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { useTranslate } from '../lib/translate/i18n/useTranslate'
import { AuthContext } from '../context/AuthContext'
import { getURLAPI } from '../utils/getURL'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const Styles = styled.div`
  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

const defaultPropGetter = () => ({})

var columns = []
var data = []

const selectItem = (select, Item) => {
  select(Item)
}

const SelectRole = ({ field, title, placeholder, value, onChanged }) => {
  const name = 'role'
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const [modalShow, setModalShow] = React.useState(false)
  const [filter, setFilter] = useState('')
  const translate = useTranslate()
  const auth = useContext(AuthContext)
  const config = auth.config
  let URLAPI = getURLAPI(config)

  let viewtValue = field && field[name] && field[name].name

  const ws_client = auth.ws_client

  //  const item_id = body.item_id

  //  const readonly = body.readonly

  const GetData_handle = function (_result) {
    const { tableName, result, readonly, action } = _result
    //console.log('result handle1 ', result)
    dispatch({
      type: 'fetch_current/get',
      payload: result,
      ob: name, //'phone',
    })
  }

  const params = {
    URL_WS: getURLAPI(auth.config, 'URL_WS'), //get address WebSocket BK from config
    auth: { userId: auth.userId, tocken: auth.token },
    handleGetData: GetData_handle,
    //handleChangeData: Refresh_handle,
    //handleSetRefresh: setStartRefresh,
    models: [
      {
        model_call_nm: 'Model_read',
        tableName: 'Roles',
        action: {
          //          metod: 'getRoles',
        },
      },
    ],
  }

  //*********** */

  const dispatch = useDispatch()
  useEffect(() => {
    if (modalShow) {
      ws_client.open_process(params)
    }
  }, [modalShow])

  const select = (Item) => {
    dispatch({
      type: 'app/set',
      payload: {
        id: field,
        field: `${name}id`,
        value: Item,
        ob: name,
      },
      ob: value,
    })

    setModalShow(false)
  }

  const app = useSelector((state) => state.app)

  const list = useSelector((state) => state.app.current[name]) || []

  const userid = app && app.body && app.body.auth_item && app.body.auth_item.id

  let roles = list

  if (filter)
    roles = roles.filter((item) => {
      //      console.log('item', item)
      //      console.log('item.name', item.name)
      return (
        (item.resource &&
          item.resource.toLowerCase().includes(filter.toLowerCase())) ||
        (item.username &&
          item.username.toLowerCase().includes(filter.toLowerCase())) ||
        (item.comments &&
          item.comments.toLowerCase().includes(filter.toLowerCase())) ||
        false
      )
      //[item.name].contains('filter')
    })

  columns = [
    {
      Header: '№',
      accessor: 'num',
    },
    {
      Header: 'Роль',
      accessor: 'name',
    },
    {
      Header: 'Коментарии',
      accessor: 'comments',
    },
  ]

  /*
  if (!isXSmall) {
    columns.push({
      Header: 'Код',
      accessor: 'code',
    })

    columns.push({
      Header: 'Тип доступа',
      accessor: 'phonetypename',
    })
  }
*/
  data = []
  //          body.workplace.map((Item) => <ItemList Item={Item} />)}

  //    let roles = body.phone

  let num2 = 1
  for (var iw2 in roles) {
    data.push({
      num: num2++,
      name: roles[iw2].name,
      comments: roles[iw2].comments,
      role: roles[iw2],
    })
  }
  //************************* */
  function Table({
    columns,
    data,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    getRowProps = defaultPropGetter,
    getCellProps = defaultPropGetter,
  }) {
    // Use the state and functions returned from useTable to build your UI
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      })

    return (
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  // Return an array of prop objects and react-table will merge them appropriately
                  {...column.getHeaderProps([
                    {
                      className: column.className,
                      style: column.style,
                    },
                    getColumnProps(column),

                    getHeaderProps(column),
                  ])}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              // Merge user row props in
              <tr {...row.getRowProps(getRowProps(row))}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      // Return an array of prop objects and react-table will merge them appropriately
                      {...cell.getCellProps([
                        {
                          className: cell.column.className,
                          style: cell.column.style,
                        },
                        getColumnProps(cell.column),
                        //  getCellProps(cell),
                      ])}
                      align="center"
                      //                    width="140px"
                    >
                      {(cell.column.id === 'name' && (
                        <Button
                          size="small"
                          color="primary"
                          variant="outlined"
                          sx={{ display: 'inline-flex', alignItems: 'center' }}
                          onClick={(req, res) => {
                            const role = cell.row.original.role
                            //          console.log(customer.id)
                            //cell.row.original['worktime_id'],

                            dispatch({
                              type: 'app/set',
                              payload: {
                                id: field,
                                field: `${name}id`,
                                value: role,
                                ob: name,
                              },
                              ob: value,
                            })
                            onChanged && onChanged()
                            setModalShow(false)
                          }} //onClickCell(cellInfo, req, res),
                          //                        onClick
                        >
                          {cell.render('Cell')}
                        </Button>
                      )) ||
                        cell.render('Cell')}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  return (
    <>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby={`contained-modal-${name}-vcenter`}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id={`contained-modal-${name}-vcenter`}>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TextField
            id="outlined-basic"
            label="Введите поисковый запрос"
            variant="outlined"
            defaultValue={filter}
            style={{
              marginBottom: 15,
              width: 450,
              display: 'flex',
              justifyContent: 'space-between',
            }}
            onChange={(item) => {
              setFilter(item.target.value)
            }}
          />
          <Styles>
            <Table
              columns={columns}
              data={data}
              /*          
          getHeaderProps={(column) => ({
            onClick: () => alert('Header!'),
          })}
          getColumnProps={(column) => ({
            onClick: () => alert('Column!'),
          })}
          */
              getRowProps={(row) => ({
                style: {
                  background: row.index % 2 === 0 ? 'rgba(0,0,0,.1)' : 'white',
                },
              })}
              getCellProps={(cellInfo) => ({
                onClick: (req, res) => {
                  console.log(cellInfo)
                }, //onClickCell(cellInfo, req, res),

                /*                style: {
                  backgroundColor: `hsl(${
                    120 * ((120 - cellInfo.value) / 120) * -1 + 120
                  }, 100%, 67%)`,
                },
              */
              })}
            />
          </Styles>
        </Modal.Body>
      </Modal>

      <TextField
        readOnly
        id="outlined-basic"
        label={placeholder}
        //variant="standard"
        variant="outlined"
        style={{
          marginBottom: 15,
          display: 'flex',
          justifyContent: 'space-between',
        }}
        //defaultValue={viewtValue || ''} //field && field[name] && field[name].name}
        value={viewtValue || ''} //field && field[name] && field[name].name}
        onClick={() => setModalShow(true)}
        onFocus={(e) => (e.target.readOnly = true)} //выключение клавиатуры при выборе значения
      />
    </>
  )
}

export default SelectRole
